"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactSwitch = _interopRequireDefault(require("react-switch"));
var _classnames = _interopRequireDefault(require("classnames"));
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _colors = _interopRequireWildcard(require("../../style/colors"));
var _variables = _interopRequireDefault(require("../../style/variables"));
var _excluded = ["checked", "classes", "className", "colorScheme", "inputClassName", "hasValidation", "height", "inputRef", "name", "onChange", "required", "setDisplayErrorsState", "setLoadingState", "theme", "width", "id"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /*:: // 

import { type ElementRef } from 'react';*/
/*:: import type {
  InjectSheetProvidedProps,
  ThemeType
} from '../../style/ThemeTypes';*/
var BOX_SHADOW = '0 3px 3px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 0 0 0.5px rgba(0, 0, 0, 0.1)';
var NOOP = function NOOP() {};
var Style = function Style(theme /*: ThemeType*/) {
  return {
    root: {
      '& .react-switch-bg': {
        border: "1px solid ".concat(theme.colors.pastelGrey)
      }
    },
    checked: {
      '& .react-switch-bg': {
        border: 'none'
      }
    },
    inputShadow: {
      display: 'none'
    }
  };
};
/*:: export type SwitchInputType = InjectSheetProvidedProps &
  HTMLInputElement & {
    colorScheme?: string,
    hasValidation?: boolean,
    inputClassName?: string,
    inputRef?: ElementRef<*>,
    onChange?: ({
      currentTarget: { id: string, name: string, value: boolean }
    }) => mixed,
    setDisplayErrorsState?: (displayErrors: boolean) => mixed,
    setLoadingState?: (loading: boolean) => mixed
  };*/
/*:: type State = {
  checked: boolean
};*/
var SwitchInput = /*#__PURE__*/function (_PureComponent) {
  function SwitchInput() {
    var _this;
    (0, _classCallCheck2.default)(this, SwitchInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SwitchInput, [].concat(args));
    (0, _defineProperty2.default)(_this, "state", {
      checked: _this.props.checked
    });
    (0, _defineProperty2.default)(_this, "handleChange", function (value /*: boolean*/) {
      var _this$props = _this.props,
        id = _this$props.id,
        name = _this$props.name,
        onChange = _this$props.onChange;
      _this.setState({
        checked: value
      });
      if (onChange) {
        return onChange({
          currentTarget: {
            id: id,
            name: name,
            value: value
          }
        });
      }
    });
    return _this;
  }
  (0, _inherits2.default)(SwitchInput, _PureComponent);
  return (0, _createClass2.default)(SwitchInput, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.checked !== prevProps.checked) {
        this.setState({
          checked: this.props.checked
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        checkedProp = _this$props2.checked,
        classes = _this$props2.classes,
        className = _this$props2.className,
        colorScheme = _this$props2.colorScheme,
        inputClassName = _this$props2.inputClassName,
        hasValidation = _this$props2.hasValidation,
        _this$props2$height = _this$props2.height,
        height = _this$props2$height === void 0 ? _variables.default.inputSwitchHeight : _this$props2$height,
        ref = _this$props2.inputRef,
        name = _this$props2.name,
        onChange = _this$props2.onChange,
        required = _this$props2.required,
        setDisplayErrorsState = _this$props2.setDisplayErrorsState,
        setLoadingState = _this$props2.setLoadingState,
        theme = _this$props2.theme,
        _this$props2$width = _this$props2.width,
        width = _this$props2$width === void 0 ? _variables.default.inputSwitchWidth : _this$props2$width,
        id = _this$props2.id,
        props = (0, _objectWithoutProperties2.default)(_this$props2, _excluded);
      var checked = this.state.checked;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: className
      }, /*#__PURE__*/_react.default.createElement(_reactSwitch.default, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.checked, checked), inputClassName),
        onChange: this.handleChange,
        onColor: colorScheme ? _colors.default[colorScheme] : _colors.default.black
      }, _objectSpread({
        checked: checked,
        height: height,
        ref: ref,
        width: width,
        id: id
      }, props))), /*#__PURE__*/_react.default.createElement("input", {
        "data-testid": "switch-input-".concat(id),
        className: classes.inputShadow,
        "data-name": name,
        onChange: NOOP,
        value: checked,
        name: name,
        required: required
      }));
    }
  }]);
}(_react.PureComponent);
(0, _defineProperty2.default)(SwitchInput, "displayName", 'SwitchInput');
(0, _defineProperty2.default)(SwitchInput, "defaultProps", {
  activeBoxShadow: BOX_SHADOW,
  boxShadow: BOX_SHADOW,
  checked: false,
  checkedIcon: false,
  colorScheme: _colors.OLIVE,
  disabled: false,
  offColor: _colors.default.pastelGrey,
  offHandleColor: _colors.default.white,
  onHandleColor: _colors.default.white,
  uncheckedIcon: false
});
var _default = exports.default = (0, _injectSheet.default)(Style)(SwitchInput);
//# sourceMappingURL=SwitchInput.js.map